import { Directive,  ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appSpaceAllowed]'
})
export class SpaceAllowedDirective {


 // private regExp: RegExp = new RegExp(/[a-zA-Z0-9 ]+$/g);
  ///^[a-zA-Z0-9._-]+$/
  private regExp: RegExp = new RegExp(/^[a-zA-Z0-9/, -]+$/);
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home','ArrowLeft','ArrowRight','Delete'];

  constructor(private element: ElementRef) {
    this.element.nativeElement.onpaste = (e:any) => {
      e.preventDefault();
      let text;
      let clp = (e.originalEvent || e).clipboardData;
      if (clp === undefined || clp === null) {
          text = (<any>window).clipboardData.getData('text') || '';
          if (text !== '') {
              text = text.replace(this.regExp, '');
              if (window.getSelection) {
                  let newNode = document.createElement('span');
                  newNode.innerHTML = text;
                  window.getSelection().getRangeAt(0).insertNode(newNode);
              } else {
                  (<any>window).selection.createRange().pasteHTML(text);
              }
          }
      } else {
          text = clp.getData('text/plain') || '';
          if (text !== '') {
              text = text.replace(this.regExp, '');
              document.execCommand('insertText', false, text);
          }
      }
  };
  }

  @HostListener('keydown', ['$event'])

  onKeyDown(event: KeyboardEvent) {

    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    let current: string = this.element.nativeElement.value;



    let next: string = current.concat(event.key);
    if (next && !String(next).match(this.regExp)) {
      event.preventDefault();
    }
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src4256039471/src/src/app/shared/directive/space-allowed.directive.ts